import { createContext, type PropsWithChildren } from "react"

import { useMapVariant } from "@be-miniapp/ui/hooks/use-map-variant"

export interface MapContextProps {
  mapType: "google" | "maplibre"
}

const MapContext = createContext<MapContextProps>({
  mapType: "maplibre",
})

interface MapProviderProps extends PropsWithChildren {
  forceMapType?: "google" | "maplibre"
}

const MapProvider = ({ children, forceMapType }: MapProviderProps) => {
  const mapType = useMapVariant()

  return (
    <MapContext.Provider
      value={{
        mapType: forceMapType ?? mapType,
      }}
    >
      {children}
    </MapContext.Provider>
  )
}

export { MapProvider, MapContext }
